// extracted by mini-css-extract-plugin
export default {"button":"bxKjp88FbEUw5eB"};